<div class="message">
  <!-- 508 audit (A, 4.1.2): a real, named button, not an unnamed div. -->
  <button type="button" class="message__close" aria-label="Close" (click)="data.closeFn()">
    <mat-icon class="close-icon" svgIcon="close" aria-hidden="true"></mat-icon>
  </button>
  <div class="message__title">{{ data?.title }}</div>
  <div class="message__content">
    <a
      role="button"
      tabindex="0"
      (keydown.enter)="data?.callbackFn()"
      (keydown.space)="$event.preventDefault(); data?.callbackFn()"
      *ngIf="data?.callbackFn" (click)="data?.callbackFn()" class="link">
      {{ data.callbackLabel }}
    </a>
    {{ data?.content }}
  </div>
</div>
